// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dropdown.socialmondrawer{background:#fff;border:1px solid #dddbda;box-shadow:1px 2px 8px 0 rgba(0,0,0,.46)}", ""]);
// Exports
module.exports = exports;
